

export enum EmptyPeriodType {
	SHOW_ALL = 'SHOW_ALL',
	SHOW_INTERSPERSED = 'SHOW_INTERSPERSED',
	DO_NOT_SHOW = 'DO_NOT_SHOW'
}


